import React from 'react'
import './styles/spinner.css'

/** A partir de este tamaño se usa doble anillo (tablas, splash, etc.). */
const DUAL_RING_MIN_SIZE = 48

/**
 * Anillo de carga SACI.
 * - Compacto: un anillo (botones, selects).
 * - Grande: doble anillo en sentidos opuestos.
 */
export default function RingSpinner({ size = 30, className = `` }) {
  const isDual = size >= DUAL_RING_MIN_SIZE
  const borderWidth = isDual
    ? Math.max(3, Math.round(size * 0.06))
    : Math.max(2, Math.round(size * 0.12))

  return (
    <span
      className={`saci-ring-spinner ${
        isDual ? `saci-ring-spinner--dual` : `saci-ring-spinner--single`
      } ${className}`.trim()}
      style={{
        width: size,
        height: size,
        ['--ring-border']: `${borderWidth}px`,
      }}
      role="status"
      aria-label="Cargando"
    >
      <span className="saci-ring-spinner__outer" />
      {isDual ? <span className="saci-ring-spinner__inner" /> : null}
    </span>
  )
}
